import { useEffect, useRef, useState } from "react";
import { useLocation } from "react-router-dom";
import { AnimatePresence, motion } from "framer-motion";

export default function GlitchTransition({ children }) {
  const { pathname } = useLocation();
  const first = useRef(true);
  const [burst, setBurst] = useState(false);

  useEffect(() => {
    if (first.current) {
      first.current = false;
      return undefined;
    }
    setBurst(true);
    const t = setTimeout(() => setBurst(false), 360);
    return () => clearTimeout(t);
  }, [pathname]);

  return (
    <div className="relative" data-testid="glitch-transition">
      <AnimatePresence mode="wait" initial={false}>
        <motion.div
          key={pathname}
          initial={{ opacity: 0, x: -8, filter: "drop-shadow(-3px 0 #00f0ff) drop-shadow(3px 0 #ff0055)" }}
          animate={{ opacity: 1, x: 0, filter: "drop-shadow(0 0 transparent) drop-shadow(0 0 transparent)" }}
          exit={{ opacity: 0, x: 8, filter: "drop-shadow(3px 0 #00f0ff) drop-shadow(-3px 0 #ff0055)" }}
          transition={{ duration: 0.22, ease: "easeOut" }}
        >
          {children}
        </motion.div>
      </AnimatePresence>

      <AnimatePresence>
        {burst && (
          <motion.div
            className="glitch-overlay"
            data-testid="glitch-overlay"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.12 }}
          >
            <span className="glitch-slice glitch-slice-a" />
            <span className="glitch-slice glitch-slice-b" />
            <span className="glitch-slice glitch-slice-c" />
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
}
